import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4f31246"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "dashboader-area mb-25" }
const _hoisted_3 = { class: "tp-dashboard-tab" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "tp-dashboard-tab-title border-0 m-0" }
const _hoisted_6 = { class: "ms-auto me-3" }
const _hoisted_7 = { class: "tpd-table mb-25" }
const _hoisted_8 = { class: "tpd-table-head" }
const _hoisted_9 = { class: "tpd-table-row" }
const _hoisted_10 = {
  class: "tpd-order-id",
  style: {"width":"100%"}
}
const _hoisted_11 = { class: "tpd-table-title" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "placeholder d-block rounded",
      style: {"width":"100%","height":"30px"}
    }),
    /*#__PURE__*/_createElementVNode("span", {
      class: "placeholder d-block rounded",
      style: {"width":"100%","height":"30px"}
    })
  ])
], -1 /* HOISTED */))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "pe-3 ps-3" }
const _hoisted_17 = { class: "alert alert-warning w-100" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_19 = { class: "tpd-table-row" }
const _hoisted_20 = {
  class: "tpd-order-name d-flex align-items-center",
  style: {"width":"calc(100% - 40px)"}
}
const _hoisted_21 = { class: "d-flex align-items-center gap-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/lms_website/images/certificate_icon.jpg",
  style: {"width":"100px","border-radius":"10px"},
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_23 = { class: "tpd-common-text mb-1" }
const _hoisted_24 = { class: "d-flex me-2 align-items-center gap-2 mt-3" }
const _hoisted_25 = {
  key: 0,
  class: "badge text-bg-primary font-w-600"
}
const _hoisted_26 = {
  key: 1,
  class: "badge text-bg-dark font-w-600"
}
const _hoisted_27 = { class: "badge text-bg-secondary font-w-600" }
const _hoisted_28 = { class: "badge text-bg-secondary font-w-600" }
const _hoisted_29 = { class: "d-flex gap-2 ms-auto align-items-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "tpd-certificate-badge-text" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tpd-certificate-badge-file" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "15",
    height: "12",
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.4851 4.007C11.8669 1.4641 9.49912 0 7.00525 0C5.75832 0 4.54641 0.364273 3.43958 1.04378C2.33275 1.7303 1.338 2.73205 0.525394 4.007C-0.175131 5.10683 -0.175131 6.89317 0.525394 7.99299C2.14361 10.5429 4.51138 12 7.00525 12C8.25219 12 9.4641 11.6357 10.5709 10.9562C11.6778 10.2697 12.6725 9.26795 13.4851 7.99299C14.1856 6.90018 14.1856 5.10683 13.4851 4.007ZM7.00525 8.83363C5.43608 8.83363 4.17513 7.56567 4.17513 6.0035C4.17513 4.44133 5.43608 3.17338 7.00525 3.17338C8.57443 3.17338 9.83538 4.44133 9.83538 6.0035C9.83538 7.56567 8.57443 8.83363 7.00525 8.83363Z",
      fill: "#24A148"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.4",
      d: "M7.00431 3.99976C5.90449 3.99976 5.00781 4.89643 5.00781 6.00326C5.00781 7.10308 5.90449 7.99976 7.00431 7.99976C8.10413 7.99976 9.00781 7.10308 9.00781 6.00326C9.00781 4.90343 8.10413 3.99976 7.00431 3.99976Z",
      fill: "#24A148"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_33 = { class: "tpd-action-btn" }
const _hoisted_34 = ["href", "download"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "13",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 8.23975V10.7466C13 11.079 12.8595 11.3979 12.6095 11.6329C12.3594 11.868 12.0203 12.0001 11.6667 12.0001H2.33333C1.97971 12.0001 1.64057 11.868 1.39052 11.6329C1.14048 11.3979 1 11.079 1 10.7466V8.23975",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.3327 5.38704L6.99935 8.52063L3.66602 5.38704",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 1V8.52061",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_36 = { class: "tpd-action-tooltip" }
const _hoisted_37 = {
  class: "modal fade",
  id: "certificateModal",
  tabindex: "-1",
  "aria-labelledby": "certificateModalLabel",
  "aria-hidden": "true"
}
const _hoisted_38 = { class: "modal-dialog modal-lg" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = {
  class: "modal-title fs-5",
  id: "certificateModalLabel"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_43 = { class: "list-group" }
const _hoisted_44 = {
  class: "d-flex align-items-center",
  style: {"column-gap":"10px"}
}
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "mb-1" }
const _hoisted_47 = {
  key: 0,
  class: "badge text-bg-primary font-w-600"
}
const _hoisted_48 = {
  key: 1,
  class: "badge text-bg-dark font-w-600"
}
const _hoisted_49 = ["onClick", "disabled"]
const _hoisted_50 = {
  key: 1,
  class: "list-group-item"
}
const _hoisted_51 = { class: "alert alert-warning m-0" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_53 = {
  class: "modal fade",
  id: "certificateViewModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "certificateViewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "modal-content" }
const _hoisted_55 = { class: "modal-header" }
const _hoisted_56 = {
  class: "modal-title fs-5",
  id: "certificateViewModalLabel"
}
const _hoisted_57 = { class: "ms-auto" }
const _hoisted_58 = {
  key: 0,
  class: "far fa-expand"
}
const _hoisted_59 = {
  key: 1,
  class: "far fa-compress"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_61 = { class: "modal-body" }
const _hoisted_62 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "PDFViewer" }, null, -1 /* HOISTED */))
const _hoisted_64 = [
  _hoisted_63
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" dashboard-content-area-start "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" dashboard-tab-area "),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString($setup.lms_website.__('Certificates')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.openCertificates && $options.openCertificates(...args))),
                class: "btn btn-sm btn-dark"
              }, _toDisplayString($setup.lms_website.__('Get Certificates')), 1 /* TEXT */)
            ])
          ])
        ])
      ]),
      _createCommentVNode(" dashboard-tab-area-end "),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h4", _hoisted_11, _toDisplayString($setup.lms_website.__('Course')), 1 /* TEXT */)
              ])
            ])
          ]),
          ($data.certificates.loading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_14))
            : _createCommentVNode("v-if", true),
          (!$options.activeCertificates?.length && !$data.certificates.loading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Not Certificates Found')), 1 /* TEXT */)
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($options.activeCertificates?.length && !$data.certificates.loading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($options.paginatedCertificates, (certificate) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: certificate.name
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", _hoisted_23, _toDisplayString(certificate.course?.title), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_24, [
                            (certificate.course?.custom_final_quiz)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($setup.lms_website.__('Final Quiz')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (!certificate.course?.custom_final_quiz)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($setup.lms_website.__('Course')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("span", _hoisted_27, _toDisplayString($setup.lms_website.__('Issue Date')) + " : " + _toDisplayString((certificate.issue_date) ? $setup.moment(certificate.issue_date).format('MMM DD, YYYY') : ''), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_28, _toDisplayString($setup.lms_website.__('Expiry Date')) + " : " + _toDisplayString((certificate.expiry_date) ? $setup.moment(certificate.expiry_date).format('MMM DD, YYYY') : ''), 1 /* TEXT */)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("button", {
                          class: "tpd-certificate-badge active w-auto",
                          onClick: $event => ($options.previewCertificate(certificate))
                        }, [
                          _createElementVNode("span", _hoisted_31, [
                            _hoisted_32,
                            _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Preview')), 1 /* TEXT */)
                          ])
                        ], 8 /* PROPS */, _hoisted_30),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("a", {
                            href: `/api/method/frappe.utils.print_format.download_pdf?doctype=LMS Certificate&name=${certificate.name}&format=${certificate.template}&no_letterhead=1&letterhead=No%20Letterhead&settings=%7B%7D&_lang=en`,
                            target: "_blank",
                            download: certificate.name
                          }, [
                            _hoisted_35,
                            _createElementVNode("span", _hoisted_36, _toDisplayString($setup.lms_website.__('Download')), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_34)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      (!$data.certificates.loading)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            "current-page": $data.certificates.currentPage,
            "total-items": $options.activeCertificates?.length,
            "items-per-page": $data.certificates.itemsPerPage,
            onPageChanged: $options.handlePageChange
          }, null, 8 /* PROPS */, ["current-page", "total-items", "items-per-page", "onPageChanged"]))
        : _createCommentVNode("v-if", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h1", _hoisted_41, _toDisplayString($setup.lms_website.__('Create Certificate')), 1 /* TEXT */),
              _hoisted_42
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["modal-body", {'form-loading':($data.create_certificate_loading || $data.courses.loading)}])
            }, [
              _createElementVNode("ul", _hoisted_43, [
                ($data.courses.list?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($data.courses.list, (course) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "list-group-item",
                        key: course.name
                      }, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("img", {
                            style: {"width":"60px","height":"55px","border-radius":"10px"},
                            src: (course.image)?course.image:'/assets/lms_website/images/placeholder.jpg',
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_45),
                          _createElementVNode("div", null, [
                            _createElementVNode("h6", _hoisted_46, _toDisplayString(course.title), 1 /* TEXT */),
                            (course.custom_final_quiz)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString($setup.lms_website.__('Final Quiz')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (!course.custom_final_quiz)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString($setup.lms_website.__('Course')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: $event => ($options.createCertificate(course)),
                            disabled: $data.create_certificate_loading,
                            class: "btn btn-sm btn-primary ms-auto"
                          }, _toDisplayString($setup.lms_website.__('Create Certificate')), 9 /* TEXT, PROPS */, _hoisted_49)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  : (_openBlock(), _createElementBlock("li", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createTextVNode(" " + _toDisplayString($setup.lms_website.__('No Courses Found')), 1 /* TEXT */)
                      ])
                    ]))
              ])
            ], 2 /* CLASS */)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-dialog modal-dialog-scrollable", {'modal-fullscreen':($data.certificateModal.full_screen),'modal-xl':(!$data.certificateModal.full_screen)}])
        }, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("h1", _hoisted_56, _toDisplayString($data.certificateModal.certificate?.course?.title), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-full-screen",
                  onClick: _cache[1] || (_cache[1] = $event => ($data.certificateModal.full_screen=!$data.certificateModal.full_screen))
                }, [
                  (!$data.certificateModal.full_screen)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_58))
                    : _createCommentVNode("v-if", true),
                  ($data.certificateModal.full_screen)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_59))
                    : _createCommentVNode("v-if", true)
                ]),
                _hoisted_60
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              (!$data.certificateModal.certificate?.template)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString($setup.lms_website.__('Template name not found')), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", {
                class: _normalizeClass(["pdf-viewer", (!$data.certificateModal.file_loaded)?'is-loading':''])
              }, _hoisted_64, 2 /* CLASS */)
            ])
          ])
        ], 2 /* CLASS */)
      ])
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}